import { Navigate, Outlet } from 'react-router'

import { useSetupState } from '@/domains/setup'

import { FullPageSpinner } from './full-page-spinner'
import { useUser } from './use-user'

/** super tools are only available in Super scope. a super acting as a company
 *  they own is just its owner, so the super routes send them back through the
 *  root redirect into their company flow. non-supers never satisfy the check. */
export function RequireSuper() {
  const { user, isLoading } = useUser()
  const { setupState } = useSetupState()

  if (isLoading) return <FullPageSpinner />
  if (!user) return <Navigate to='/login' replace />
  if (!setupState) return <FullPageSpinner />
  if (!user.isSuper || setupState.scope !== 'super') {
    return <Navigate to='/' replace />
  }
  return <Outlet />
}
